export const FolderApi = Symbol.for('FolderApi');
